import * as THREE from 'three';

// WHERE THE FLOOR IS — which is not the bottom of the bounding box.
//
// Grounding a venue by dropping its lowest point to zero assumes that point is
// the floor. It usually is not: an outer wall runs down past the slab into a
// foundation, a kerb sits proud outside the door, one stray vertex hangs below.
// This store's box bottoms out at −0.15 while the floor you walk on is at +0.09,
// because the wall extends a quarter-unit below it — so the room lands a quarter
// unit in the air, and you step down into the street on the way out.
//
// The floor is findable by what makes it a floor: it is the WIDEST FLAT thing
// near the bottom. A wall is tall, a shelf is small, a slab is neither. Returns
// the top of that surface — what you actually stand on — or null when nothing
// convincing is found, in which case the caller keeps the old box behaviour.
export function detectFloor(root) {
  let lo = Infinity; let hi = -Infinity;
  const items = [];
  const b = new THREE.Box3();
  root.traverse((o) => {
    if (!o.isMesh || !o.geometry) return;
    if (!o.geometry.boundingBox) o.geometry.computeBoundingBox();
    if (!o.geometry.boundingBox) return;
    b.copy(o.geometry.boundingBox).applyMatrix4(o.matrixWorld);
    if (!isFinite(b.min.x)) return;
    lo = Math.min(lo, b.min.y); hi = Math.max(hi, b.max.y);
    items.push({
      minY: b.min.y, maxY: b.max.y,
      h: b.max.y - b.min.y,
      area: (b.max.x - b.min.x) * (b.max.z - b.min.z),
    });
  });
  if (!items.length || !isFinite(lo)) return null;
  const span = hi - lo || 1;
  // Near the bottom, flat, and wide. The thresholds are deliberately loose —
  // this only has to beat "the lowest vertex in the building", which is a very
  // low bar, and a false negative costs nothing because the caller falls back.
  const candidates = items.filter((it) => (
    it.minY <= lo + span * 0.2 && it.h <= span * 0.06
  ));
  if (!candidates.length) return null;
  const best = candidates.reduce((a, c) => (c.area > a.area ? c : a));
  // Ignore a "floor" that is not actually broad — a doormat is flat and low too.
  const widest = items.reduce((a, c) => Math.max(a, c.area), 0);
  if (best.area < widest * 0.5) return null;
  return best.maxY;
}

